import { Component } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { DtoClientForViewVM } from '../../../Model/clients/DtoClientForViewVM';
import { Router } from '@angular/router';
import { UserType } from '../../../Shared/Enums/UserType';
import { AuthService } from '../../../Shared/Services/auth.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { ClientService } from '../../../Services/client.service';
import { takeUntil } from 'rxjs/internal/operators/takeUntil';
import { Subject } from 'rxjs/internal/Subject';
import { CustomToastrService } from '../../../Shared/Services/custom-toastr.service';
import { MatDialogRef } from '@angular/material/dialog';
import { SharedService } from '../../../Shared/Services/shared.service';

@Component({
  selector: 'app-add-clientfor-order',
  templateUrl: './add-client-for-order.component.html',
  styleUrl: './add-client-for-order.component.scss'
})
export class AddClientforOrderComponent {
  form!: FormGroup;
  private destroy$: Subject<boolean> = new Subject<boolean>();
  AllClients: DtoClientForViewVM[] = [];
  constructor(private router: Router, private auth: AuthService, private spinner: NgxSpinnerService,
    private api: ClientService, private toastrService: CustomToastrService, private shared: SharedService,
    private dialogRef: MatDialogRef<AddClientforOrderComponent>) { }

  ngOnInit() {
    this.spinner.show();
    this.initForm();
    this.GetAllClients();
  }

  private initForm() {
    this.form = new FormGroup({
      ClientId: new FormControl('', [Validators.required]),
      Date: new FormControl('', [Validators.required])
    });
  }

  get f() {
    return this.form.controls;
  }

  GetAllClients() {
    if (this.auth.isAuthenticated([UserType.Agent, UserType.Workshop])) {
      this.api.GetAllClients()
        .pipe(takeUntil(this.destroy$))
        .subscribe(
          {
            next: (res: any) => {
              this.AllClients = res.payload;
              this.spinner.hide();
            },
            error: (error: any) => {
              this.spinner.hide();
              this.toastrService.showErrorToast('Error', "SomethingWentWrong");
            }
          });
    } else {
      this.router.navigateByUrl('dashboard/not-authorized');
    }
  }

  onClose(): void {
    this.dialogRef.close();
  }

  Save() {
    if (this.form.valid) {
      this.dialogRef.close({ invoicesDate: this.form?.value?.Date, selectedClient: this.form?.value?.ClientId });
    }
    else {
      this.shared.FireFormValidation(this.form);
    }
  }
}
